import React from "react"
import styled from "styled-components"

import buttonTertiaryCss from "@irati/ui/src/Button/styled/tertiaryButtonCss"

import {spacingCss, SpacingProps} from "../../global/css"
import {ButtonCssProps} from "../../Button/styled"

export interface AnchorProps extends SpacingProps, ButtonCssProps {
  href?: string
  target?: string
  plain?: boolean
  onClick?: (evt: React.MouseEvent) => void
}

export default styled.a<AnchorProps>`
  font-family: "PerkSans", sans-serif;
  ${({plain}) => !plain && buttonTertiaryCss}
  ${spacingCss}
`
